import { render, staticRenderFns } from "./TextTruncate.vue?vue&type=template&id=b68432ae&scoped=true&"
import script from "./TextTruncate.vue?vue&type=script&lang=js&"
export * from "./TextTruncate.vue?vue&type=script&lang=js&"
import style0 from "./TextTruncate.vue?vue&type=style&index=0&id=b68432ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68432ae",
  null
  
)

export default component.exports